(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-language-relationship', {
            parent: 'entity',
            url: '/public-site-language-relationship?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteLanguageRelationship.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-language-relationship/public-site-language-relationships.html',
                    controller: 'PublicSiteLanguageRelationshipController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteLanguageRelationship');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-language-relationship-detail', {
            parent: 'entity',
            url: '/public-site-language-relationship/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteLanguageRelationship.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-language-relationship/public-site-language-relationship-detail.html',
                    controller: 'PublicSiteLanguageRelationshipDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteLanguageRelationship');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSiteLanguageRelationship', function($stateParams, PublicSiteLanguageRelationship) {
                    return PublicSiteLanguageRelationship.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-language-relationship',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-language-relationship-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language-relationship/public-site-language-relationship-dialog.html',
                    controller: 'PublicSiteLanguageRelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteLanguageRelationship', function(PublicSiteLanguageRelationship) {
                            return PublicSiteLanguageRelationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-language-relationship.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language-relationship/public-site-language-relationship-dialog.html',
                    controller: 'PublicSiteLanguageRelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                active: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-language-relationship', null, { reload: 'public-site-language-relationship' });
                }, function() {
                    $state.go('public-site-language-relationship');
                });
            }]
        })
        .state('public-site-language-relationship.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language-relationship/public-site-language-relationship-dialog.html',
                    controller: 'PublicSiteLanguageRelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteLanguageRelationship', function(PublicSiteLanguageRelationship) {
                            return PublicSiteLanguageRelationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-language-relationship', null, { reload: 'public-site-language-relationship' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-language-relationship.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language-relationship/public-site-language-relationship-delete-dialog.html',
                    controller: 'PublicSiteLanguageRelationshipDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSiteLanguageRelationship', function(PublicSiteLanguageRelationship) {
                            return PublicSiteLanguageRelationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-language-relationship', null, { reload: 'public-site-language-relationship' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
